import { assertPackageVersion } from '@dynamic-labs-sdk/assert-package-version';

import {
  name as packageName,
  version as packageVersion,
} from '../../package.json';
assertPackageVersion(packageName, packageVersion);

export { addTronExtension } from '../addTronExtension';
export { getTronWeb } from '../getTronWeb';
export { isTronNetworkProvider } from '../isTronNetworkProvider';
export { isTronWalletAccount } from '../isTronWalletAccount';
export { sendTransaction } from '../sendTransaction';
export type { TronNetworkProvider } from '../TronNetworkProvider.types';
export type { TronWalletAccount } from '../TronWalletAccount.types';
export type {
  TronBroadcastReturnSignedTransaction,
  TronWeb,
} from '../TronWalletProvider.types';
